// TODO #12345 move functions or rename file
import { PickerValue } from '@mui/x-date-pickers/internals';
import { format } from 'date-fns';
import { de, enUS } from 'date-fns/locale';
import { ILanguage } from 'my-poppies-b2b-types';

export const getNowAsNumberInSeconds = () => Math.floor(new Date().getTime() / 1000);

export const getNowAsNumberInMilliseconds = () => Math.floor(new Date().getTime());

export const convertTimestampToDate = (timestamp: number | undefined) => {
  return new Date((timestamp ?? 0) * 1000);
};

export const prettifyTimestamp = (timestamp: number, currentLanguage: ILanguage) => {
  return format(new Date(timestamp * 1000), 'eeee, PPpp', { locale: currentLanguage === 'en' ? enUS : de });
};

export const prettifyTimestamp_weekDay = (timestamp: number, currentLanguage: ILanguage) => {
  return format(new Date(timestamp * 1000), 'eeee', { locale: currentLanguage === 'en' ? enUS : de });
};

export const prettifyTimestamp_dateOnly = (timestamp: number, currentLanguage: ILanguage) => {
  return format(new Date(timestamp * 1000), 'PP', { locale: currentLanguage === 'en' ? enUS : de });
};

export const prettifyTimestamp_timeOnly = (timestamp: number, currentLanguage: ILanguage) => {
  return format(new Date(timestamp * 1000), 'pp', { locale: currentLanguage === 'en' ? enUS : de });
};

export const prettifyTimestampWithoutYear = (timestamp: number, currentLanguage: ILanguage) => {
  return format(new Date(timestamp * 1000), 'PPPP', { locale: currentLanguage === 'en' ? enUS : de }).slice(
    0,
    currentLanguage === 'de' ? -5 : -6
  );
};

export const convertPickerDateToTimestamp = (date: PickerValue) => {
  if (!date) {
    return 0;
  }
  return Math.floor(date.getTime() / 1000);
};
